<template>
    <guide-page v-bind:config="pageConfig" :wxa-page="wxaPage" :wxa-page-param="wxaPageParam" :shareHaderName="shareHaderName"></guide-page>
</template>

<script>
import sensorsdata from 'sa-sdk-javascript';
import GuidePage from '../component/GuidePage.vue';

export default {
  name: 'AboutOrder',
  components: {
    guidePage: GuidePage,
  },
  data() {
    return {
      wxaPage: 'pages/me/guide/guide-page/guide-page',
      wxaPageParam: 'key=9',
      shareHaderName: '订单处理',
      pageConfig: {
        sections: [
          {
            steps: [
              {
                title: '订单查看',
                description: [
                  '店员及顾客均可通过小程序实时查看订单状态，第一时间掌握最新状态；',
                ],
                sub: [
                  {
                    title: '小程序查看订单状态',
                    images: [{ name: '7_01' }],
                  },
                  {
                    title: '官网查看订单状态',
                    images: [{ name: '7_02' }],
                  },
                ],
              },
              {
                title: '寄送快递',
                description: [
                  '- 如该订单有纸质资料需要寄送，寄送后点击「填写快递信息」填写快递公司及快递单号；',
                  '- 如需查看寄送地址，依次点击「查看订单」、「查看详情」即可查看地址；',
                ],
                sub: [
                  {
                    title: '使用官网填写快递信息',
                    images: [
                      { name: '7_03' },
                      { name: '7_05' },
                      { name: '7_06' },
                    ],
                  },
                  {
                    title: '使用小程序填写快递信息',
                    images: [{ name: '7_07' }, { name: '7_08' }],
                  },
                ],
              },
              {
                title: '资料不完善',
                description: [
                  '- 资料不合格或需要修改时，店员和顾客会收到资料不合格的提醒，按照以下步骤修改不合格的资料后重新提交即可。',
                ],
                sub: [
                  {
                    images: [{ name: '7_09' }, { name: '7_10' }],
                  },
                ],
              },
            ],
          },
        ],
      },
    };
  },
  mounted() {
    sensorsdata.track('UserGuide', {
      guide_name: '订单处理',
    });
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/guide/sub/AboutOrder.vue